<template>
  <div class="d-flex flex-column justify-content-center px-1">
    <HeaderBar />
    <div class="d-flex flex-column mb-2 mt-4" style="font-size: 15px; font-weight: 500">
      <div class="add-economic-record-title1 mt-2 text-center "> Desparacitación</div>
      <div class="d-flex justify-content-center headTitle">{{ fincaName }}</div>
    </div>
    <validation-observer ref="GanForm">
      <div class="mt-2">
        <b-form class="mt-2 mb-4" @submit.prevent="">
          <!-- date -->
          <b-form-group class="datePicker flex-fill" label="Fecha">
            <validation-provider #default="{ errors }" name="Fecha" rules="required">
              <b-form-datepicker v-model="date" class="form-control"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :min="minCfgDate"
                :max="maxCfgDate" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- vaccineName -->
          <b-form-group label="Nombre del desparasitante" label-for="dewomerName">
            <validation-provider #default="{ errors }" name="Nombre del desparasitante" vid="dewormerName"
              rules="required">
              <b-form-input id="dewormerName" v-model="dewormerName" :state="errors.length > 0 ? false : null"
                name="dewormerName" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <div class="d-flex">
            <b-form-group label="Tipo de desparasitante" label-for="dewormerType" class="w-75">
              <validation-provider #default="{ errors }" name="Tipo de desparasitante" vid="dewormerName"
                rules="required">
                <b-form-select id="dewormerType" :options="dewormerTypeOptions" :values="dewormerTypeOptions.value"
                  v-model="dewormerType" label="text" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Días de retiro:" label-for="retreatDays" class="w-50 ml-1">
              <validation-provider #default="{ errors }" name="Días de retiro" vid="retreatDays" rules="required">
                <b-form-input v-model="retreatDays" type="number" :state="errors.length > 0 ? false : null"
                  name="retreatDays" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <b-form-group label="Ingrediente Activo (opcional) " label-for="activeIngredient">
            <validation-provider #default="{ errors }" name="Ingrediente activo" vid="retreatDays" rules="required">
              <b-form-select v-model="activeIngredient" :options="IngredientOptions" :values="IngredientOptions.value"
                label="text" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>


          <b-form-group label="Seleccionar Animal" label-for="animalSelector">
            <validation-provider #default="{ errors }" name="Animal" rules="required">
              <b-form-select v-model="selectedAnimal" :options="animalOptions" value-field="id" text-field="text"
                label="text">
              </b-form-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>


          <!-- submit buttons -->
          <b-button type="submit" v-on:click="addHealthRecord"
            class="bg-primary dataButton mt-5 mb-5 d-flex align-items-center justify-content-center ml-3">
            <div class="ml-5">Incluir Evento</div>
            <div class="pl-5" style="color: #d7b92c">
              <feather-icon icon="PlusIcon" size="18" />
            </div>
          </b-button>
        </b-form>
      </div>
    </validation-observer>
    <ControlMenu />
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { required } from "@validations";
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BFormSelect,
  BForm,
  BFormCheckboxGroup,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import ControlMenu from "@/components/ControlMenu.vue";
import HeaderBar from '@/components/HeaderBar.vue'
import { VueGoodTable } from 'vue-good-table'
import axios from 'axios'

export default {
  components: {
    BButton,
    flatPickr,
    BFormCheckboxGroup,
    BForm,
    BFormSelect,
    BFormGroup,
    required,
    ControlMenu,
    HeaderBar,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    VueGoodTable,
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 119)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return {
      status: "",
      dateDefault: "",
      checked: [],
      maxCfgDate: maxDate,
      minCfgDate: minDate,
      age: null,
      activeIngredient: null,
      IngredientOptions: [],
      dewormerType: null,
      dewormerTypeOptions: [],
      retreatDays: 0,
      dewormerName: null,
      options: [],
      type_id: 2,
      ageOptions: [
        { text: "10" },
        { text: "15" },
        { text: "21" },
        { text: "30" },
        { text: "33" },
      ],
      fincaName: localStorage.getItem('currentFarmName'),
      date: now,
      animal: {
        sex: 0
      },
      selectedAnimal: null,
      animalOptions: [],
      animals: [],
      pageLength: 25,
      columns: [
        {
          label: 'CODIGO',
          field: 'number',
        },
        {
          label: 'ANIMAL',
          field: 'name',
        },
        {
          label: 'SEXO',
          field: 'sex',
          type: 'boolean'
        },
        {
          label: 'PESO',
          field: 'weight',
        },
        {
          label: 'EDAD',
          field: 'age',
          type: 'number'
        },
      ],
      rows: [],
      dewormings: [],
    };
  },

  methods: {
    async fetchDewormerType(config) {
      fetch(this.$apiUrl + "list/health_data_types?type=2", config)
        .then(response => response.json())
        .then(result => {
          this.dewormerTypeOptions = result.health_data_types.map(item => { return { text: item.name, value: item.id } })
        })
    },

    async fetchactiveIngredient(config) {
      fetch(this.$apiUrl + "list/health_data_types?type=5", config)
        .then(response => response.json())
        .then(result => {
          console.log(result);
          this.IngredientOptions = result.health_data_types.map(item => { return { text: item.name, value: item.id } })
        })
    },

    async fetchAnimals(config) {
      let farmId = localStorage.getItem('currentFarm');
      fetch(this.$apiUrl + "list/animals?farm_id=" + farmId + "&state=1&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
          this.animalOptions = result.animals.map(item => { return { id: item.id, text: item.name } });
        })
    },



    addHealthRecord() {
      this.$refs.GanForm.validate().then(success => {
        if (success) {
          let self = this;
          const token = localStorage.getItem("accessToken");
          const config = { headers: { "X-Authorization": `Bearer ${token}` } };
          this.dewormings = [{ animal_id: this.selectedAnimal, product_name: this.dewormerName, dewormer_id: this.dewormerType, dewormer_ingredient: this.activeIndredient, date: this.date, type_id: this.type_id, days: this.retreatDays, farm_id: localStorage.getItem('currentFarm') }]; 
          console.log("Dewo", this.dewormings);
          console.log('Items', this.items);
          var request = this.dewormings.map(items => this.$http.post("add/health_records", items, config));
          axios.all(request)
            .then(() => {
              this.$swal({
                title: 'Registro de desparacitación',
                text: 'Se insertaron los registros de desparasitación de manera satisfactoria',
                type: 'success',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false
              }).then(function () {
                history.back();
              });
            });
        }
      })

    }

  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = { headers: { "X-Authorization": `Bearer ${token}` } };
    this.fetchAnimals(config);
    this.fetchDewormerType(config);
    this.fetchactiveIngredient(config);
  }
};
</script>

<style lang="scss">
.titles {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: #5e5873;
}

.dataButton {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #ffffff;
  flex: none;
  order: 1;
}

.headTitle {
  font-weight: 600;
  font-size: 24px;
  color: #5E8F23;
}

@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
